import React, { useState } from "react";
import {
  Button,
  Header,
  Modal,
  Form,
  TextArea,
  Input,
  Grid,
  Segment,
  Checkbox,
  Divider,
} from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "../../../app/common/modals/modalSlice";
import {
  // updateDocAddSharingInDb,
  // updateTransAddSharingInDb,
  updateDocInDb,
  updatePartyInDb,
  addEmailToDb,
} from "../../../app/firestore/firestoreService";
import { functionShareWithAgent } from "../../../app/firestore/functionsService";
import { sendCustomDocSharingEmail } from "../../../app/firestore/firestoreService";
import { convertFullName, partyIsAgent } from "../../../app/common/util/util";
import { serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";
// import _ from "lodash";
import ModalWrapper from "../../../app/common/modals/modalWrapper";
import { useMediaQuery } from "react-responsive";
import { handleDocSharingUpdate } from "./docSharingUtils";
import {
  getEmailTemplateMessage,
  getEmailTemplateSubject,
} from "../../emailTemplates/emailTemplateDefaults";
// import LoadingComponent from "../../../app/layout/LoadingComponent";

export default function DocCustomEmailModal({
  doc,
  party,
  transaction,
  defaultEmailTemplate,
}) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });
  const { allParties } = useSelector((state) => state.transaction);
  const { currentUserProfile } = useSelector((state) => state.profile);
  const [error, setError] = useState("");

  const defaultSubject = doc?.emailSharingDefaults?.subjectPlusAddress
      ? doc.emailSharingDefaults.subjectPlusAddress +
          (transaction?.address?.street
            ? " for " + transaction?.address?.street
            : ` from ${
                currentUserProfile?.firstName ||
                transaction.agentProfile?.firstName ||
                ""
              }`)
      : `New documents have been shared with you${
          transaction?.address?.street ? ` for ${transaction.address.street}` : ""
        }`;
  const defaultMessage =
    (doc?.emailSharingDefaults?.message
      ? `Hi ${party.firstName || "there"}
        
        ` + doc.emailSharingDefaults.message
      : `Hi ${party.firstName || "there"},
      
I'm sharing new documents with you that you can view by clicking the "View Documents" button above. Please let me know if you have any questions.`) +
      `

Thank you,
${currentUserProfile?.firstName} ${currentUserProfile?.lastName}
${currentUserProfile?.email}`;
  const [customSubject, setCustomSubject] = useState(
    getEmailTemplateSubject(defaultEmailTemplate, defaultSubject)
  );
  const [customMessage, setCustomMessage] = useState(
    getEmailTemplateMessage(defaultEmailTemplate, defaultMessage)
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const agentProfile = transaction.agentProfile?.lastName
    ? transaction.agentProfile
    : currentUserProfile;

  // Determine available email addresses for CC/BCC
  const agentEmail = transaction.agentProfile?.email || currentUserProfile?.email || "";
  const tcEmail = transaction.transactionCoordinator?.email || "";
  const agentAsTcEmail = transaction.agentAsTransactionCoordinator?.email || "";

  // transaction.assistant is an array
  const assistants = Array.isArray(transaction.assistant) ? transaction.assistant : [];

  // Manager assistants array
  const managerAssistants = Array.isArray(transaction.agentProfile?.managerAssistants) ? transaction.agentProfile.managerAssistants : [];

  // Determine if there's a TC on the transaction (could be TC or Agent as TC)
  const hasTc = transaction.hasTc || transaction.hasAgentAsTc;
  const effectiveTcEmail = tcEmail || agentAsTcEmail;

  // Initialize CC/BCC state
  const [ccAgent, setCcAgent] = useState(false);
  const [bccAgent, setBccAgent] = useState(false);
  const [ccTc, setCcTc] = useState(false);
  const [bccTc, setBccTc] = useState(false);

  // CC/BCC state for each assistant (keyed by email)
  const [ccAssistants, setCcAssistants] = useState(() => {
    const initial = {};
    if (assistants && Array.isArray(assistants) && assistants.length > 0) {
      assistants.forEach((a) => {
        if (a.email) initial[a.email] = false;
      });
    }
    return initial;
  });
  const [bccAssistants, setBccAssistants] = useState(() => {
    const initial = {};
    if (assistants && Array.isArray(assistants) && assistants.length > 0) {
      assistants.forEach((a) => {
        if (a.email) initial[a.email] = false;
      });
    }
    return initial;
  });

  // CC/BCC state for each manager assistant (keyed by email)
  const [ccManagerAssistants, setCcManagerAssistants] = useState(() => {
    const initial = {};
    if (managerAssistants && Array.isArray(managerAssistants) && managerAssistants.length > 0) {
      managerAssistants.forEach((ma) => {
        if (ma.email) initial[ma.email] = false;
      });
    }
    return initial;
  });
  const [bccManagerAssistants, setBccManagerAssistants] = useState(() => {
    const initial = {};
    if (managerAssistants && Array.isArray(managerAssistants) && managerAssistants.length > 0) {
      managerAssistants.forEach((ma) => {
        if (ma.email) initial[ma.email] = false;
      });
    }
    return initial;
  });

  function handleCancel() {
    dispatch(closeModal({ modalType: "DocCustomEmailModal" }));
  }

  // function sendOfferAlertEmailToAdmin(party, doc) {
  //   if (
  //     partyIsAgent(party.role) &&
  //     doc.title === "Contract to Buy and Sell, Residential" // should be startsWith
  //   ) {
  //     // This would need to be imported if needed
  //     // sendOfferSubmittedEmail(currentUserProfile, party, transaction, doc);
  //   }
  // }

  async function handleSendCustomEmail() {
    setIsSubmitting(true);

    try {
      // const partyRoleCamel = _.camelCase(party.role);
      // sharedBy is for linked agent who the agent is sharing on behalf of
      const sharedByName = agentProfile.firstName + " " + agentProfile.lastName;

      // Check if sharing with a non-user agent and handle linking
      if (
        partyIsAgent(party.role) &&
        party.isUser &&
        !party.isLinked &&
        !party.declinedLinking
      ) {
        // This case should be handled by the DocShareAgentLinking modal first
        toast.error("Agent linking should be handled first");
        setIsSubmitting(false);
        return;
      }

      // Add sharing to document
      // const restoreAgentClients = false;
      await handleDocSharingUpdate(
        doc,
        party,
        allParties,
        transaction,
        currentUserProfile,
        dispatch
      );
      // await updateDocAddSharingInDb(
      //   doc.id,
      //   party,
      //   transaction,
      //   allParties,
      //   restoreAgentClients
      // );
      // await updateTransAddSharingInDb(transaction.id, party, transaction);

      // Handle linked agent case
      if (partyIsAgent(party.role) && party.isUser && party.isLinked) {
        await updateDocInDb(
          doc.id,
          {
            sentToAgent: true,
            sentToAgentId: party.id,
            sentDocIsDirty: false,
            sentToAgentAt: serverTimestamp(),
          },
          true
        );
        let resultFromSharing = await functionShareWithAgent({
          doc: doc,
          party: party,
          sharedBy: sharedByName,
          sharedStatus: true,
          sharedStatusAt: serverTimestamp(),
        });
        const sharedLinkedDocId = resultFromSharing;
        await updateDocInDb(
          doc.id,
          {
            sharedLinkedDocId: sharedLinkedDocId,
          },
          true
        );
      }

      // Build CC and BCC email lists based on checkbox selections
      const additionalCcEmails = [];
      const additionalBccEmails = [];
      const ccEmailsAndRoles = [];
      const bccEmailsAndRoles = [];

      // Agent CC/BCC
      if (ccAgent && agentEmail && agentEmail !== party.email) {
        additionalCcEmails.push(agentEmail);
        ccEmailsAndRoles.push({
          role: "Agent",
          email: agentEmail,
          firstName: agentProfile?.firstName || "",
          lastName: agentProfile?.lastName || "",
        });
      }
      if (bccAgent && agentEmail && agentEmail !== party.email) {
        additionalBccEmails.push(agentEmail);
        bccEmailsAndRoles.push({
          role: "Agent",
          email: agentEmail,
          firstName: agentProfile?.firstName || "",
          lastName: agentProfile?.lastName || "",
        });
      }

      // TC CC/BCC
      if (ccTc && effectiveTcEmail && effectiveTcEmail !== party.email) {
        additionalCcEmails.push(effectiveTcEmail);
        const tcInfo = transaction.transactionCoordinator || transaction.agentAsTransactionCoordinator || {};
        ccEmailsAndRoles.push({
          role: "TC",
          email: effectiveTcEmail,
          firstName: tcInfo.firstName || "",
          lastName: tcInfo.lastName || "",
        });
      }
      if (bccTc && effectiveTcEmail && effectiveTcEmail !== party.email) {
        additionalBccEmails.push(effectiveTcEmail);
        const tcInfo = transaction.transactionCoordinator || transaction.agentAsTransactionCoordinator || {};
        bccEmailsAndRoles.push({
          role: "TC",
          email: effectiveTcEmail,
          firstName: tcInfo.firstName || "",
          lastName: tcInfo.lastName || "",
        });
      }

      // Assistants CC/BCC (from transaction.assistant array)
      if (assistants && Array.isArray(assistants)) {
        assistants.forEach((assistant) => {
          if (assistant.email && assistant.email !== party.email) {
            if (ccAssistants[assistant.email]) {
              additionalCcEmails.push(assistant.email);
              ccEmailsAndRoles.push({
                role: "Assistant",
                email: assistant.email,
                firstName: assistant.firstName || "",
                lastName: assistant.lastName || "",
              });
            }
            if (bccAssistants[assistant.email]) {
              additionalBccEmails.push(assistant.email);
              bccEmailsAndRoles.push({
                role: "Assistant",
                email: assistant.email,
                firstName: assistant.firstName || "",
                lastName: assistant.lastName || "",
              });
            }
          }
        });
      }

      // Manager Assistants CC/BCC (from transaction.managerAssistants array)
      if (managerAssistants && Array.isArray(managerAssistants)) {
        managerAssistants.forEach((ma) => {
          if (ma.email && ma.email !== party.email) {
            if (ccManagerAssistants[ma.email]) {
              additionalCcEmails.push(ma.email);
              ccEmailsAndRoles.push({
                role: "Manager Assistant",
                email: ma.email,
                firstName: ma.firstName || "",
                lastName: ma.lastName || "",
              });
            }
            if (bccManagerAssistants[ma.email]) {
              additionalBccEmails.push(ma.email);
              bccEmailsAndRoles.push({
                role: "Manager Assistant",
                email: ma.email,
                firstName: ma.firstName || "",
                lastName: ma.lastName || "",
              });
            }
          }
        });
      }

      // Send custom email with additional CC/BCC
      await sendCustomDocSharingEmail(
        [party],
        "sharing",
        currentUserProfile,
        transaction,
        customSubject,
        customMessage,
        additionalCcEmails,
        additionalBccEmails
      );

      // Send offer alert to admin if applicable
      // sendOfferAlertEmailToAdmin(party, doc);

      // Add custom email to email history
      const emailHistoryData = {
        transactionId: transaction.id,
        subject: customSubject,
        message: customMessage,
        from:
          (currentUserProfile?.firstName + " " || "") +
          (currentUserProfile?.lastName || ""),
        toEmails: [party.email],
        ccEmails: additionalCcEmails,
        ccEmailsAndRoles: ccEmailsAndRoles,
        bccEmails: additionalBccEmails,
        bccEmailsAndRoles: bccEmailsAndRoles,
        otherEmailsBcc: "",
        otherEmailsCc: "",
        otherEmailsTo: "",
        toEmailsAndRoles: [
          {
            role: party.role,
            email: party.email,
            firstName: party.firstName,
            lastName: party.lastName,
          },
        ],
        type: "custom_document_sharing",
        documentName: doc.name,
        recipientRole: party.role,
        recipientName: convertFullName(party),
        isCustomEmail: true,
      };

      await addEmailToDb(emailHistoryData, {});

      // Update party's last email sent time
      await updatePartyInDb(party, {
        lastEmailSentAt: new Date(),
      });

      toast.success("Document shared with custom email successfully!");
      dispatch(closeModal({ modalType: "DocCustomEmailModal" }));
    } catch (error) {
      console.error("Error sharing document with custom email:", error);
      toast.error("Failed to share document. Please try again.");
      setIsSubmitting(false);
    }
  }

  return (
    <ModalWrapper open={true} size="large">
      <Segment clearing>
        <div
          className={
            isMobile
              ? "zero horizontal margin small top margin"
              : "medium horizontal margin small top margin"
          }
        >
          {/* <Modal open={true} size="small"> */}
          <Header
            icon="mail"
            content={`Optional - Customize Email to ${party.role} ${convertFullName(
              party
            )}`}
          />
          <Modal.Content>
            <p>
              <strong>To:</strong> {party.role} {convertFullName(party)} ({party.email})
              <br />
              <strong>Document:</strong> {doc.name}
            </p>

            <Form>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <label>
                      <strong>Subject Line:</strong>
                    </label>
                    <Input
                      fluid
                      value={customSubject}
                      onChange={(e) => setCustomSubject(e.target.value)}
                      placeholder="Email subject"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column width={16}>
                    <label>
                      <strong>Message:</strong>
                    </label>
                    <TextArea
                      value={customMessage}
                      onChange={(e) => {
                        let value = e.target.value;

                        const allowed = /^[a-zA-Z0-9\s'!.,()$%#@&:?]*$/m;

                        if (!allowed.test(value)) {
                          setError(
                            "Only letters, numbers, spaces, and ' ! . , ( ) $ % # @ & : ? are allowed."
                          );
                          // Strip invalid characters, but keep newlines
                          value = value.replace(
                            /[^a-zA-Z0-9\s'!.,()$%#@&:?]/g,
                            ""
                          );
                        } else {
                          setError("");
                        }

                        //  Enforce 1,000-character limit
                        if (value.length > 2000) {
                          value = value.slice(0, 2000);
                          setError("Message cannot exceed 2000 characters.");
                        }

                        setCustomMessage(value);
                      }}
                      placeholder="Email message"
                      rows={11}
                      style={{ width: "100%" }}
                    />
                    <div
                      style={{
                        textAlign: "right",
                        fontSize: "0.85em",
                        color: "#666",
                      }}
                    >
                      {customMessage.length}/2000
                    </div>
                    {error && (
                      <div
                        style={{
                          color: "red",
                          fontSize: "0.85em",
                          marginTop: "4px",
                        }}
                      >
                        {error}
                      </div>
                    )}
                  </Grid.Column>
                </Grid.Row>

                {/* CC/BCC Options */}
                <Grid.Row>
                  <Grid.Column width={16}>
                    <Divider />
                    <label>
                      <strong>Copy Options:</strong>
                    </label>
                    <Grid stackable>
                      <Grid.Row>
                        <Grid.Column width={7}>
                         
                    <div style={{ marginTop: "10px" }}>
                      {/* Agent CC/BCC - show if current user is not the agent or if there's an agent email */}
                      {agentEmail  && (
                        <div style={{ marginBottom: "8px" }}>
                         
                          <Checkbox
                            label="CC"
                            checked={ccAgent}
                            onChange={(_, { checked }) => {
                              setCcAgent(checked);
                              if (checked) setBccAgent(false);
                            }}
                            style={{ marginRight: "15px" }}
                          />
                          <Checkbox
                            label="BCC"
                            checked={bccAgent}
                            onChange={(_, { checked }) => {
                              setBccAgent(checked);
                              if (checked) setCcAgent(false);
                            }}
                          />
                           <span style={{ fontWeight: "500", marginRight: "10px", marginLeft: "10px" }}>
                            Agent ({agentProfile?.firstName} {agentProfile?.lastName}):
                          </span>
                        </div>
                      )}

                      {/* TC CC/BCC - show if there's a TC on the transaction */}
                      {hasTc && effectiveTcEmail && (
                        <div style={{ marginBottom: "8px" }}>
                          
                          <Checkbox
                            label="CC"
                            checked={ccTc}
                            onChange={(_, { checked }) => {
                              setCcTc(checked);
                              if (checked) setBccTc(false);
                            }}
                            style={{ marginRight: "15px" }}
                          />
                          <Checkbox
                            label="BCC"
                            checked={bccTc}
                            onChange={(_, { checked }) => {
                              setBccTc(checked);
                              if (checked) setCcTc(false);
                            }}
                          />
                          <span style={{ fontWeight: "500", marginRight: "10px", marginLeft: "10px" }}>
                            TC ({(transaction.transactionCoordinator?.firstName || transaction.agentAsTransactionCoordinator?.firstName || "")} {(transaction.transactionCoordinator?.lastName || transaction.agentAsTransactionCoordinator?.lastName || "")}):
                          </span>
                        </div>
                      )}

                      {/* Assistants CC/BCC - from transaction.assistant array */}
                      {assistants && Array.isArray(assistants) && assistants.length > 0 && assistants.filter((a, index, self) => a.email && a.email !== currentUserProfile?.email && a.email !== party.email && self.findIndex((x) => x.email === a.email) === index).map((assistant) => (
                        <div key={assistant.email} style={{ marginBottom: "8px" }}>
                          
                          <Checkbox
                            label="CC"
                            checked={ccAssistants[assistant.email] || false}
                            onChange={(_, { checked }) => {
                              setCcAssistants((prev) => ({ ...prev, [assistant.email]: checked }));
                              if (checked) setBccAssistants((prev) => ({ ...prev, [assistant.email]: false }));
                            }}
                            style={{ marginRight: "15px" }}
                          />
                          <Checkbox
                            label="BCC"
                            checked={bccAssistants[assistant.email] || false}
                            onChange={(_, { checked }) => {
                              setBccAssistants((prev) => ({ ...prev, [assistant.email]: checked }));
                              if (checked) setCcAssistants((prev) => ({ ...prev, [assistant.email]: false }));
                            }}
                          />
                          <span style={{ fontWeight: "500", marginRight: "10px", marginLeft: "10px" }}>
                            Assistant ({assistant.firstName || ""} {assistant.lastName || ""}):
                          </span>
                        </div>
                      ))}
                </div></Grid.Column> 
                <Grid.Column width={9}>
                <div style={{ marginTop: "10px" }}>
                      {managerAssistants?.length > 0 && (<label>
                      <strong>Manager Assistants:</strong>
                    </label>)}
                      {/* Manager Assistants CC/BCC - from transaction.managerAssistants array */}
                      {managerAssistants?.filter((ma, index, self) => ma.email && ma.email !== currentUserProfile?.email && ma.email !== party.email && self.findIndex((m) => m.email === ma.email) === index).map((ma) => (
                        <div key={ma.email} style={{ marginBottom: "8px" }}>
                                       
                     <Checkbox
                            label="CC"
                            checked={ccManagerAssistants[ma.email] || false}
                            onChange={(_, { checked }) => {
                              setCcManagerAssistants((prev) => ({ ...prev, [ma.email]: checked }));
                              if (checked) setBccManagerAssistants((prev) => ({ ...prev, [ma.email]: false }));
                            }}
                            style={{ marginRight: "15px" }}
                          />
                          <Checkbox
                            label="BCC"
                            checked={bccManagerAssistants[ma.email] || false}
                            onChange={(_, { checked }) => {
                              setBccManagerAssistants((prev) => ({ ...prev, [ma.email]: checked }));
                              if (checked) setCcManagerAssistants((prev) => ({ ...prev, [ma.email]: false }));
                            }}
                          />
                          <span style={{ fontWeight: "500", marginRight: "10px", marginLeft: "10px" }}>
                             {ma.title || ""} ({ma.firstName || ""} {ma.lastName || ""}):
                          </span>
                        </div>
                      ))}
                      </div>
                      </Grid.Column>
                        </Grid.Row>
                    </Grid>
                      <div style={{ marginTop: "10px" }}>
                      {/* Show message if no CC/BCC options available */}
                      {/* {!((agentEmail && agentEmail !== currentUserProfile?.email) ||
                         (hasTc && effectiveTcEmail && effectiveTcEmail !== currentUserProfile?.email) ||
                         assistants.some((a) => a.email && a.email !== currentUserProfile?.email && a.email !== party.email) ||
                         managerAssistants.some((ma) => ma.email && ma.email !== currentUserProfile?.email && ma.email !== party.email)) && (
                        <p style={{ color: "#888", fontStyle: "italic" }}>
                          No additional recipients available for CC/BCC.
                        </p>
                      )} */}
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>

            {/* <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "15px",
                borderRadius: "5px",
                marginTop: "15px",
              }}
            >
              <p>
                <strong>Partial Preview of email that will be sent:</strong>
              </p>
              <p>
                <strong>Subject:</strong> {customSubject}
              </p>
              <p>
                <strong>Message:</strong>
              </p>
              <div
                style={{
                  fontStyle: "italic",
                  marginLeft: "10px",
                  overflowY: "auto",
                  maxHeight: "200px",
                }}
              >
                <p>Hi {party.firstName || "there"},</p>
                <p style={{ whiteSpace: "pre-wrap" }}>{customMessage}</p>
                <p>
                  Thank you,
                  <br />
                  {agentProfile.firstName} {agentProfile.lastName}
                  <br />
                  {agentProfile.email}
                </p>
              </div>
            </div> */}
          </Modal.Content>

          <Modal.Actions>
            <Button onClick={handleCancel} disabled={isSubmitting} title="Cancel will not send the email but document has been shared.">
              Cancel - Don't send an email
            </Button>
            <Button
              color="blue"
              onClick={handleSendCustomEmail}
              loading={isSubmitting}
              disabled={
                isSubmitting || !customSubject.trim() || !customMessage.trim()
              }
            >
              Send Email
            </Button>
          </Modal.Actions>
          {/* </Modal> */}
        </div>
      </Segment>
    </ModalWrapper>
  );
}
